import { render } from "./w-loadable.vue?vue&type=template&id=004b2dfd&scoped=true"
import script from "./w-loadable.vue?vue&type=script&lang=js"
export * from "./w-loadable.vue?vue&type=script&lang=js"

import "./w-loadable.vue?vue&type=style&index=0&id=004b2dfd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004b2dfd"]])

export default __exports__